import gsap from 'gsap';
import {Flip} from 'gsap/Flip';
import {plausibleEvent} from "../utils";

export class IndicatorModal {
    constructor(el, modal) {
        this.el = el;
        this.modal = modal;

        this.closeIndicatorButton = this.modal.querySelector('[data-indicator-modal-close]');

        this.el.addEventListener('click', (e) => {

            const targetValue = e.target.closest('button').getAttribute('data-target');

            this.targetModal = this.modal.querySelector(`[data-id="${targetValue}"]`);

            if (!this.targetModal) {
                return;
            }

            this.openIndicator(this.targetModal);
        });

        this.closeIndicatorButton.addEventListener('click', (e) => {
            this.modal.querySelectorAll('[data-id]').forEach((indicator) => {
                this.closeIndicator(indicator);
            });
        });
    }

    openIndicator(modal) {

        plausibleEvent('openIndicator', {indicatorId: modal?.dataset?.id});

        const background = this.el.querySelector('.c-indicator-card__bg');

        const innerModal = modal.querySelector('.c-indicator-modal__inner');
        const rect = this.modal.querySelector('[data-modal-inner]').offsetHeight;

        if (innerModal > rect) {
            background.style.setProperty('--height', innerModal + "px");
        } else {
            background.style.setProperty('--height', rect + "px");
        }

        const tl = gsap.timeline({
            onStart: () => {
                const state = Flip.getState(background);
                background.classList.add("full-screen");
                Flip.from(state, {
                    duration: 0.8,
                    ease: "power3.inOut",
                })
            },
        });

        tl.to([modal, this.closeIndicatorButton], {
            autoAlpha: 1,
            delay: 0.8,
        });

        tl.fromTo(
            [modal.querySelector('.c-indicator-modal__info'), modal.querySelector('.c-indicator-modal__trend')],
            {
                opacity: 0,
                translateY: -20,
            },
            {
                opacity: 1,
                translateY: 0,
                duration: 0.6,
                ease: 'power2.out',
            },
            '-=0.5'
        );

        tl.fromTo(
            innerModal,
            {
                height: rect.offsetHeight,
            },
            {
                height: innerModal.offsetHeight,

                duration: 1.4,
                ease: 'power2.out',
            },
            '-=1.35'
        );
    }

    closeIndicator(modal) {
        plausibleEvent('closeIndicator', {indicatorId: modal?.dataset?.id});

        const squares = this.el.querySelectorAll('.c-indicator-card__bg');

        squares.forEach((square) => {
            square.classList.remove("full-screen");
        });

        const tl = gsap.timeline({
            onComplete: () => {
                gsap.set(modal, {
                    autoAlpha: 0,
                });
            },
        });

        tl.to(
            [modal, this.closeIndicatorButton],
            {
                opacity: 0,
                duration: 0.3,
            },
            '<'
        );
    }

    destroy() {
    }
}